import { SENTRY_DSN } from '@env';
import { APP_NAME, APP_VERSION } from 'src/app/settings';

export type TSentryCommonConfig = {
  dsn: string;
  tracesSampleRate: number;
  release: string;
  dist?: string;
};

export type TSentryCaptureContext = {
  tags?: Record<string, string | number | boolean>;
  extra?: Record<string, unknown>;
};

export abstract class SentryClass {
  isSentryInitialized: boolean;

  constructor() {
    this.isSentryInitialized = false;
  }
  public init(App: React.ComponentType<Record<string, unknown>>) {
    if (!this.isSentryInitialized) {
      if (__DEV__) {
        console.debug('[Vendor] [Sentry] disabled in local environment');
        return;
      }

      if (!SENTRY_DSN) {
        console.error('[Vendor] [Sentry] DSN is missing');
        return;
      }

      try {
        const SentryApp = this.initSentry(App, {
          dsn: SENTRY_DSN,
          tracesSampleRate: 1.0,
          release: `${APP_NAME}@${APP_VERSION}`,
          dist: process.env.SENTRY_DIST,
        });

        this.isSentryInitialized = true;

        return SentryApp;
      } catch (error) {
        this.isSentryInitialized = false;
      }

      return App;
    }
  }

  abstract initSentry(
    App: React.ComponentType<Record<string, unknown>>,
    commonConfig: TSentryCommonConfig,
  ): React.ComponentType<Record<string, unknown>>;
  abstract captureException(error: any, context?: TSentryCaptureContext): void;
  abstract setUserInfo(userId: string | null, userType: string): void;
}
